var _title, _desc, _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "info")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 1.2,
    stdDeviation: 0.5,
    floodOpacity: 0.7
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(1.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 16,
    r: 16,
    style: {
      filter: "url(#shadow)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9931487,6 C18.5574243,6 19.0307276,6.19501001 19.4129556,6.58503003 C19.8043529,6.97505005 20,7.44669644 20,7.99997947 C20,8.55326249 19.8043529,9.02490888 19.4129556,9.4149597 C19.0216613,9.80491812 18.548358,10 17.9931487,10 C17.4471088,10 16.9783387,9.80491812 16.5870444,9.4149597 C16.1956471,9.02490888 16,8.55326249 16,7.99997947 C16,7.44669644 16.191114,6.97505005 16.5733419,6.58503003 C16.9647392,6.19501001 17.4380425,6 17.9931487,6 Z M19,12 L16.0165681,21.6785517 C15.8517188,22.2321606 15.7692392,22.5951038 15.7692392,22.7675865 C15.7692392,22.8673368 15.8128403,22.9626697 15.9001522,23.0533798 C15.9874641,23.1350497 16.0797182,23.175936 16.1766949,23.175936 C16.341654,23.175936 16.5066131,23.1078264 16.6714624,22.9717099 C17.1081319,22.6359901 17.6320034,22.0279345 18.2431868,21.1476459 L18.7380642,21.4198789 C17.2729812,23.8065921 15.7158636,25 14.066492,25 C13.4358693,25 12.931437,24.8366602 12.5529755,24.5099806 C12.1842886,24.174158 12,23.7521455 12,23.2439429 C12,22.9082231 12.0824796,22.4816905 12.2474387,21.9644477 L14.2702198,15.4575648 C14.4642829,14.8314289 14.5613694,14.3594898 14.5613694,14.0418504 C14.5613694,13.8422471 14.4691153,13.6652443 14.2848267,13.5110474 C14.1004283,13.3567477 13.8482671,13.2795979 13.5280136,13.2795979 C13.3824937,13.2795979 13.2078698,13.284118 13.004142,13.2931582 L13.1933728,12.7486922 L18.1267709,12 L19,12 Z",
    id: "Shape",
    fill: "#ffffff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.5b8cc8a3.svg";
export { ForwardRef as ReactComponent };